module.exports = __webpack_public_path__ + "static/media/fishes.ea259706.png";